module.exports = __webpack_public_path__ + "img/firefox_step_2.c1e4be0d.jpg";